import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import React from 'react';

interface ReloadButtonProps {
  descriptor: string;
  loading: boolean;
  onClick: () => void;
}

export const ReloadContainerNavItem: React.FC<ReloadButtonProps> = ({ descriptor, loading, onClick }) => (
  <Box mt="auto" p={1}>
    <Button
      variant="outlined"
      onClick={onClick}
      fullWidth
      disabled={loading}
      startIcon={loading ? null : <RefreshIcon />}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : `Reload ${descriptor}`}
    </Button>
  </Box>
);
